import { useEffect, useState } from 'react';
import { about as fallbackAbout } from '../data/about';
import { ABOUT_QUERY, isSanityConfigured, sanityClient } from '../cms/sanityClient';
import { urlForImage } from '../cms/sanityImage';

function mapSanityAbout(data) {
  const photos = (data.photos || [])
    .map((photo) => {
      const src = urlForImage(photo.image);
      if (!src) return null;
      return { src, alt: photo.alt || '' };
    })
    .filter(Boolean);

  return {
    title: data.title || fallbackAbout.title,
    quote: data.quote || fallbackAbout.quote,
    paragraphs: data.paragraphs?.length ? data.paragraphs : fallbackAbout.paragraphs,
    hobbies: data.hobbies?.length ? data.hobbies : fallbackAbout.hobbies,
    photos: photos.length ? photos : fallbackAbout.photos,
  };
}

export default function useAboutContent() {
  const [content, setContent] = useState(fallbackAbout);
  const [loading, setLoading] = useState(isSanityConfigured);
  const [source, setSource] = useState(isSanityConfigured ? 'sanity' : 'local');

  useEffect(() => {
    if (!isSanityConfigured || !sanityClient) {
      setLoading(false);
      setSource('local');
      return undefined;
    }

    let cancelled = false;

    sanityClient
      .fetch(ABOUT_QUERY)
      .then((data) => {
        if (cancelled || !data) return;
        setContent(mapSanityAbout(data));
        setSource('sanity');
      })
      .catch(() => {
        if (!cancelled) {
          setContent(fallbackAbout);
          setSource('local');
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { content, loading, source };
}
